import React from 'react'
import PropTypes from 'prop-types'
import {
  AsideDetailsDescription,
  AsideDetailsLabel,
  AsideDetailsTitle,
  DetailsPanelTopSection
} from '../../../global/styles'
import {
  BADGE_SIZES,
  BADGE_VARIANTS
} from '../../../const/UIvariants'
import Badge from '../../../components/UI/Badge'
import LoadingSpinner from '../../../components/LoadingSpinner'
import Typography from '../../../components/UI/Typography'
import { useGetStoreOrderQuery } from '../../../api/api.generated'
import {
  ShopDetailsWrap,
  ShopInfoBlock,
  TagsWrap
} from './styles'

const OrderDetails = ({ activeId, showStore }) => {
  const { data: orderData, isLoading, error: loadError } = useGetStoreOrderQuery(activeId)

  return (
    <>
      {isLoading && <LoadingSpinner />}
      {loadError && 
        <Typography variant="textS" color="red">Network Error</Typography>
      }        
      {orderData && (
        <>
          <DetailsPanelTopSection>
            <AsideDetailsTitle align="center">Order Details</AsideDetailsTitle>
          </DetailsPanelTopSection>
          <ShopDetailsWrap>
            <ShopInfoBlock>
              <AsideDetailsLabel align="left">Order #</AsideDetailsLabel>
              <AsideDetailsDescription>
                {orderData.code}
              </AsideDetailsDescription>
            </ShopInfoBlock>
            {showStore &&
            <ShopInfoBlock>
              <AsideDetailsLabel align="left">Store</AsideDetailsLabel>
              <AsideDetailsDescription>
                {orderData.shopName}
              </AsideDetailsDescription>
            </ShopInfoBlock>
            }
            <ShopInfoBlock>
              <AsideDetailsLabel align="left">Date</AsideDetailsLabel>
              <AsideDetailsDescription>
                {orderData.createdAt}
              </AsideDetailsDescription>
            </ShopInfoBlock>
            <ShopInfoBlock>
              <AsideDetailsLabel align="left">First Name</AsideDetailsLabel>
              <AsideDetailsDescription>
                {orderData.firstName}
              </AsideDetailsDescription>
            </ShopInfoBlock>
            <ShopInfoBlock>
              <AsideDetailsLabel align="left">Last Name</AsideDetailsLabel>
              <AsideDetailsDescription>
                {orderData.lastName}
              </AsideDetailsDescription>
            </ShopInfoBlock>
            { orderData.phone &&
            <ShopInfoBlock>
              <AsideDetailsLabel align="left">Phone</AsideDetailsLabel>
              <AsideDetailsDescription>
                {orderData.phone === null ? '' : '+' }{orderData.phone}
              </AsideDetailsDescription>
            </ShopInfoBlock>
            }
            { orderData.address &&
            <ShopInfoBlock>
              <AsideDetailsLabel align="left">Address</AsideDetailsLabel>
              <AsideDetailsDescription>
                {orderData.address}
              </AsideDetailsDescription>
            </ShopInfoBlock>
            }
            <ShopInfoBlock>
              <AsideDetailsLabel align="left">Total</AsideDetailsLabel>
              <AsideDetailsDescription>
                ${orderData.total}
              </AsideDetailsDescription>
            </ShopInfoBlock>
            <ShopInfoBlock>
              <AsideDetailsLabel align="left">Fee</AsideDetailsLabel>
              <AsideDetailsDescription>
                ${orderData.fee}
              </AsideDetailsDescription>
            </ShopInfoBlock>
            <ShopInfoBlock>
              <AsideDetailsLabel align="left">Shipping</AsideDetailsLabel>
              <TagsWrap>
                <Badge
                  size={BADGE_SIZES.LARGE}
                  label={orderData.isDelivery ? 'Delivery' : 'Click and Collect'}
                  variant={orderData.isDelivery ? BADGE_VARIANTS.GREEN : BADGE_VARIANTS.PINK}
                />
              </TagsWrap>
            </ShopInfoBlock>
            <ShopInfoBlock>
              <AsideDetailsLabel align="left">Withdrawn</AsideDetailsLabel>
              <TagsWrap>
                <Badge
                  size={BADGE_SIZES.LARGE}
                  label={orderData.transfer ? 'Yes' : 'No'}
                  variant={orderData.transfer ? BADGE_VARIANTS.GREEN : BADGE_VARIANTS.PINK}
                />
              </TagsWrap>
            </ShopInfoBlock>
            <ShopInfoBlock>
              <AsideDetailsLabel align="left">Status</AsideDetailsLabel>
              <TagsWrap>
                <Badge
                  size={BADGE_SIZES.LARGE}
                  label={orderData.statusId === 1 ? 'Not Fullfiled' : 'Fullfiled'}
                  variant={orderData.statusId === 1 ? BADGE_VARIANTS.PINK : BADGE_VARIANTS.GREEN}
                />
              </TagsWrap>
            </ShopInfoBlock>
          </ShopDetailsWrap>
        </>
      )}
    </>
  )
}

export default OrderDetails

OrderDetails.defaultProps = {}

OrderDetails.propTypes = {
  activeId: PropTypes.number.isRequired,
  showStore: PropTypes.bool.isRequired
}
